import React, {useMemo} from 'react';
import {InputGroup} from '@blueprintjs/core';

import {BaseBlock, ContentActions, ContentOptions} from '../types';
import {ContentCard, ContentToolbar} from '../components';
import {defaultContentActions, defaultContentOptions} from '../constants';
import {useCreateBlocks, useUpdateBlockContentJson} from '../hooks';
import {CLOSING_TAG, FOR_IN_STATEMENT, FOR_START_STATEMENT} from './constants';
import {getForRowVariableName} from './utils';

import './ForLoop.scss';

interface ForStartProps {
  content: BaseBlock;
  options?: ContentOptions;
  actions?: ContentActions;
}

export const ForStart = ({
  content,
  options = defaultContentOptions,
  actions = defaultContentActions,
}: ForStartProps) => {
  options = useMemo((): ContentOptions => ({...defaultContentOptions, ...options}), [options?.readOnly]);
  actions = useMemo((): ContentActions => ({...defaultContentActions, ...actions}), []);

  const uid = content.uid;

  const rowVariableName = getForRowVariableName(content.name);

  const {updating, updateBlockContentJson} = useUpdateBlockContentJson(uid, options.readOnly, options.autosave);
  useCreateBlocks(content);

  const onSourceChange = (event: any) => {

    const value = event.target.value;

    const newContent = {
      'statement': `{% for ${rowVariableName} in ${value} %}`,
      'value': value,
    };

    const keys = Object.keys(newContent);
    const values = Object.values(newContent);

    updateBlockContentJson(keys, values);
  }

  return (
    <ContentCard
      key={content.id}
      type={content.type}
      contentId={uid}
      disabled={options.readOnly}
      noContentElement={undefined}
      allowCollapse={false}
    >
      <div className="content__for-start">
        <ContentToolbar
          contentId={uid as string}
          showSelect={false}
          updating={updating}
          onDelete={actions.onDelete}
          showDelete={options.showDelete}
          showDuplicate={false}
          showSave={false}
          disabled={options.readOnly}
        />
        <div className="content-card__content__form">
          <div className="for-statement">
            <div className="for-statement__item">{FOR_START_STATEMENT}</div>
            <div className="for-statement__item bold">{rowVariableName}</div>
            <div className="for-statement__item">{FOR_IN_STATEMENT}</div>
            <InputGroup
              defaultValue={content.value}
              className="for-statement__item"
              onChange={onSourceChange}
              disabled={options.readOnly}
              small={true}
            />
            <div className="for-statement__item">{CLOSING_TAG}</div>
          </div>
        </div>
      </div>
    </ContentCard>
  )
}

export default ForStart;
